import {
  HeaderGroup,
  OnChangeFn,
  RowSelectionState,
  TableOptions,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable,
} from "@tanstack/react-table";

interface PTableProps<Data> extends TableOptions<Data> {
  rowSelection: RowSelectionState;
  setRowSelection: OnChangeFn<RowSelectionState>;
}
export function PTable<Data>({ data, columns, ...props }: Partial<PTableProps<Data>>) {
  const table = useReactTable({
    data: data || [],
    columns: columns || [],
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    columnResizeMode: "onChange",
    defaultColumn: {
      minSize: 5,
    },
    ...props,
  });

  return (
    <div className="overflow-x-auto">
      <table className="table-fixed w-fit">
        <thead className="rounded-tr bg-gray-50 h-10">
          {table.getHeaderGroups().map((headerGroup: HeaderGroup<Data>) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <td
                  className="text-xs font-semibold relative py-0 px-2"
                  key={header.id}
                  style={{ width: header.column.getSize() }}>
                  {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                  {header.column.getCanResize() && (
                    <div
                      {...{
                        onDoubleClick: () => header.column.resetSize(),
                        onMouseDown: header.getResizeHandler(),
                        className: `bg-gray-200 absolute top-0 h-full right-0 w-1 bg-opacity-50 cursor-col-resize select-none touch-none ${header.column.getIsResizing() ? "" : ""}`,
                      }}
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td className="text-xs py-0.5 px-2" key={cell.id} style={{ width: cell.column.getSize() }}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
